import { render, staticRenderFns } from "./cityAreaRefundList.vue?vue&type=template&id=2f40891a&scoped=true"
import script from "./cityAreaRefundList.vue?vue&type=script&lang=js"
export * from "./cityAreaRefundList.vue?vue&type=script&lang=js"
import style0 from "./cityAreaRefundList.vue?vue&type=style&index=0&id=2f40891a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f40891a",
  null
  
)

export default component.exports